import { jsx, jsxs } from "react/jsx-runtime";
import { Box } from "../Box/Box.mjs";
import { Text } from "../Text/Text.mjs";
import { Stack } from "../Stack/Stack.mjs";
const FieldLabel = ({ tertiaryLabel, data }) => {
  if (!tertiaryLabel) {
    return null;
  }
  return /* @__PURE__ */ jsx(Stack, { space: "xsmall", data, children: /* @__PURE__ */ jsx(Box, { component: "span", display: "flex", justifyContent: "flexEnd", children: tertiaryLabel ? /* @__PURE__ */ jsxs(Text, { children: [
    " ",
    tertiaryLabel
  ] }) : null }) });
};
export {
  FieldLabel
};
